export default __webpack_public_path__ + "static/media/Chauragh-Temple.38a44352.jpg";